// extracted by mini-css-extract-plugin
export default {"container":"GetTicket_container__-OTyE","one":"GetTicket_one__ICS93","notices":"GetTicket_notices__m0hfe"};